export default __webpack_public_path__ + "static/media/pic7.cedb7117.jpg";